// src/pages/APIList.js
import React from 'react';

function APIList() {
  return (
    <div className="w3-container">
      <h1 className="myheading">API Data List</h1>
        <div class="w3-container w3-center">
        <img src="https://picsum.photos/id/1039/350/250" class="w3-image w3-round w3-hover-grayscale responsive" alt="API Data List" />
        </div>

      <p>Yo-ho-ho brigantine lateen sail belaying pin fore pillage belay jury mast spirits. Haul wind ye maroon black jack gibbet Arr list square-rigged yard. Tack mizzenmast crow's nest Spanish Main driver topgallant mizzen gangway Sail ho.</p>
      <p>Sail ho trysail rum pinnace tender ho crow's nest Jolly Roger yawl. Hardtack maroon spirits chase guns shrouds chase interloper chantey cackle fruit. Trysail landlubber or just lubber Barbary Coast pirate jack hang the jib wench plunder sheet.</p>
      <p>Cat o'nine tails Pirate Round lugsail jolly boat weigh anchor swab chase hornswaggle bowsprit. Fore chantey bucko loot gangplank topgallant yawl gunwalls pink. Piracy hail-shot fathom deadlights trysail American Main matey gaff grapple.</p>
    </div>
  )
}

export default APIList;